/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'reaction/defend': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" d="M9.5 0h1v4h-1zM9.5 16h1v4h-1zM16 9.5h4v1h-4zM0 9.5h4v1H0zM5.67 13.5L10 6l4.33 7.5z"/><path pid="1" d="M16 4v12H4V4h12m1-1H3v14h14V3z"/>'
  }
})
